import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [40.797772, -73.954387, 5.6],
  [40.797582, -73.954505, 5.6],
  [40.797383, -73.954613, 5.8],
  [40.797185, -73.95472, 5.8],
  [40.797005, -73.954849, 5.8],
  [40.796839, -73.95501, 5.8],
  [40.796678, -73.955187, 5.8],
  [40.796525, -73.955364, 5.8],
  [40.796364, -73.955546, 5.6],
  [40.796201, -73.955696, 5.4],
  [40.79601, -73.955782, 5],
  [40.795814, -73.955723, 4.4],
  [40.795651, -73.955551, 4.8],
  [40.795565, -73.955326, 5],
  [40.79556, -73.955047, 5.4],
  [40.795651, -73.954827, 6.6],
  [40.795777, -73.954629, 8.4],
  [40.795892, -73.95443, 9.8],
  [40.795967, -73.954216, 11],
  [40.79601, -73.95399, 12],
  [40.795994, -73.95376, 13.6],
  [40.795908, -73.953561, 15.6],
  [40.795777, -73.953416, 17.2],
  [40.795621, -73.953347, 18.6],
  [40.79546, -73.953363, 20],
  [40.795324, -73.953475, 21.4],
  [40.795227, -73.953636, 22.4],
  [40.795152, -73.953829, 23.2],
  [40.795077, -73.954017, 24.2],
  [40.794988, -73.954205, 25.2],
  [40.794873, -73.954355, 26.2],
  [40.794744, -73.954495, 27.2],
];

export default stream;
